import { Row, Col, Table, Card, message, Button, Input, Modal, Select } from 'antd';
import { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { EditOutlined, DeleteOutlined } from "@ant-design/icons"
import SearchBox from '../components/SearchBox';
import useFetch from "../_fetch";
import { entity_type, user_role } from '../consts';
import PermissionModal from '../components/PermissionModal';
import { useNavigate, useParams } from "react-router-dom";
import RequestFy from './requestFy';
import { useGetAllClients, useUpdateClient, useDeleteClient, useGetAllCompanies } from "../utils/queryUtils";
import { setReloadClient, setReloadFinancialYear } from '../store/action/reload';
import { normalizeString as normalizePath } from '../utils/pathUtils';
import AddFy from './AddFY';

const { Option } = Select;

const normalizeString = (str) => {
    return str?.trim().replace(/\s+/g, '');
};

const normalizeEntityName = (str) => {
    return str?.trim();
};

export default function Entities() {
    let dispatch = useDispatch();
    const placeholder = "Search Entities..."
    const [editTitle, setEditTitle] = useState(false);
    const [entityTypeState, setEntityTypeState] = useState(entity_type);
    const [editAbn, setEditAbn] = useState(false)
    const { role, _id } = useSelector((st) => st.user);
    const user = useSelector((st) => st.user);
    const [title, setTitle] = useState("");
    const [abn, setAbn] = useState("");
    const [permissionModalOpen, setPermissionModalOpen] = useState(null);
    const [companyList, setCompanyList] = useState([]);
    const { company } = useSelector(st => st.selected);
    const { reloadClient, reloadFY } = useSelector(st => {
        return st.reload
    })
    const [buttonVisible, setButtonVisible] = useState('');
    const [openFyModal, setOpenFyModal] = useState(false);
    const { companyName } = useParams();
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [currentRecord, setCurrentRecord] = useState(null);
    const [targetCompanyId, setTargetCompanyId] = useState(null);
    const selectedPrimaryClient = useSelector(st => st.selected.primaryClient);


    const { data } = useGetAllCompanies(_id);
    const all = data;
    useEffect(() => {
        if (all && all.length > 0) {
            setCompanyList(all);
        }
    }, [all]);
    const [pagination, setPagination] = useState({
        current: 1,
        pageSize: 10,
        total: 0,
    });
    const [tableFilters, setTableFilters] = useState({});
    const clientsdatawithpagination = useGetAllClients(companyName, pagination.current, tableFilters, selectedPrimaryClient);
    const loading = clientsdatawithpagination.isLoading || clientsdatawithpagination.isFetching;
    const [showData, setShowData] = useState(clientsdatawithpagination?.data?.data);
    const handleTableChange = (pagination, filters) => {
        try {
            setPagination((prev) => ({
                ...prev,
                current: pagination.current,
            }));
            const newFilters = {};
            newFilters.entity_type = filters.entity_type;
            setTableFilters((prev) => {
                return { ...prev, ...newFilters }
            })
        }
        catch (err) {
            console.error(err)
        }
    };
    const { mutateAsync: updateClient, isSuccess: isUpdateSuccess } = useUpdateClient();
    const { mutateAsync: deleteClient } = useDeleteClient();
    const _fetch = useFetch()

    const handleEdittitle = (record) => {
        setTitle(record?.title);
        setEditTitle(record?._id);

    };
    const handleEditabn = (record) => {
        setAbn(record?.abn);
        setEditAbn(record?._id);
    };

    const handleMigrateQuery = (record) => {
        setCurrentRecord(record);
        setIsModalVisible(true);
    };

    useEffect(() => {
        if (!isModalVisible) {
            setTargetCompanyId(null);
        }
    }, [isModalVisible])


    const handleSave = async () => {
        if (!targetCompanyId) return;

        try {
            let res = await _fetch(`${process.env.REACT_APP_API_URL}/client/migrateEntity`, {
                method: "POST",
                body: {
                    to_company_id: targetCompanyId,
                    entity_id: currentRecord?._id,
                }
            })
            let result = await res.json();
            if (res.status === 200) {
                message.success("Query migrated successfully");
                clientsdatawithpagination.refetch();
            } else {
                message.error(result.response);
            }
            setIsModalVisible(false);
            setTargetCompanyId(null);
            setCurrentRecord(null);
        } catch (error) {
            console.error("Migration failed", error);
        }
    };

    const functionFilter = Object.keys(entityTypeState).map((e) => ({ text: e, value: e }));

    const navigate = useNavigate();
    async function reloadCache() {
        await clientsdatawithpagination.refetch()
        setShowData(clientsdatawithpagination?.data?.data);
        setPagination((prev) => {
            return {
                ...prev,
                current: clientsdatawithpagination?.data?.pagination?.current,
                total: clientsdatawithpagination?.data?.pagination?.total,
            }
        });
        dispatch(setReloadClient(false));
        dispatch(setReloadFinancialYear(false));
    }
    useEffect(() => {
        if (reloadClient || reloadFY || selectedPrimaryClient) {
            reloadCache()
        }
    }, [reloadClient, reloadFY, selectedPrimaryClient]);

    useEffect(() => {
        if (clientsdatawithpagination?.data?.data) {
            setShowData(clientsdatawithpagination?.data?.data);
            const dynamicEntityTypesArray = clientsdatawithpagination?.data?.pagination?.entity_type;
            if (Array.isArray(dynamicEntityTypesArray)) {
                const dynamicEntityTypesObject = dynamicEntityTypesArray.reduce((acc, type) => {
                    acc[type] = type;
                    return acc;
                }, {});

                setEntityTypeState(prev => ({
                    ...prev,
                    ...dynamicEntityTypesObject
                }));
            }
            setPagination((prev) => {
                return {
                    ...prev,
                    current: clientsdatawithpagination?.data?.pagination?.current,
                    total: clientsdatawithpagination?.data?.pagination?.total,
                }
            });
        }
    }, [clientsdatawithpagination?.data?.data]);



    const columnData = [
        {
            title: `Entity (${showData?.length})`,
            key: "entity",
            width: 250,
            render: (record) => (
                <div className='pointer custom-blue-text' style={{ fontWeight: "600", color: "#blue" }}>
                    {editTitle === record?._id ? (
                        <Input
                            value={title}
                            size='small'
                            autoFocus

                            style={{
                                fontSize: '14px',
                                width: "100%",
                                border: '1px solid #ccc',
                            }}
                            onChange={(e) => {
                                setTitle(e.target.value);
                            }}
                            onBlur={() => {
                                setTitle(normalizeEntityName(title));
                            }}
                        />
                    ) : (
                        record.status === 'PROPOSED' ? (
                            <div style={{ display: 'flex' }}>
                                <p className='my-2 mx-2' style={{ color: 'blue', fontWeight: '600' }}>{normalizeEntityName(record?.title)}</p>
                            </div>
                        ) : (
                            <p className='my-2'>{normalizeEntityName(record?.title)}</p>
                        )
                    )}
                </div>
            ),
            onCell: (record) => ({
                    onClick: () => {
                    if (selectedPrimaryClient?._id) {
                        navigate(`/${companyName}/${selectedPrimaryClient?._id}/${normalizePath(record?.title + ':' + record.abn)}`);
                        return
                    }
                    navigate(`/${companyName}/${normalizePath(record?.title + ':' + record.abn)}`)
                },
            }),
        },
        {
            title: `Entity Type`,
            key: "entity_type",
            width: 250,
            render: (record) => (
                <div className='pointer custom-blue-text' style={{ fontWeight: "600", color: "#blue" }}>
                    <div style={{ display: 'flex' }}>
                        <p className='my-2 mx-2' style={{ color: 'black', fontWeight: '600' }}>{normalizeString(record?.entity_type)}</p>
                    </div>
                </div>
            ),
            filters: functionFilter,
        },
        {
            title: `ABN ID`,
            key: "abn",
            render: (record) => (
                <div className='pointer'>
                    {
                        editAbn === record?._id ? (
                            <Input
                                value={abn}
                                size='small'

                                style={{
                                    fontSize: '14px',
                                    width: "100%",
                                    border: '1px solid #ccc',

                                }}
                                autoFocus
                                onChange={(e) => {
                                    setAbn(e.target.value);
                                }}
                                onBlur={() => {
                                    setAbn(normalizeString(abn));
                                }}
                            />
                        ) :
                            <p>
                                {normalizeString(record?.abn)}
                            </p>
                    }
                </div>
            ),
            onCell: (record) => ({
                onClick: () => {
                    if (!editAbn && !editTitle) {
                        navigate(
                            `/${companyName}/${normalizeEntityName(record?.title + ':' + record?.abn)}`
                        );
                    }
                },
            }),
        },
        {
            title: `${role === user_role.PRIMARY_CLIENT ? "Financial Year" : "No. of Financial Years"}`,
            dataIndex: "fy_count",
            key: "fy_count",
            render: (text, record) => (
                <div className="pointer">
                    {/* <span onClick={() => navigate(`/${companyName}/${normalizeEntityName(record?.title)}`)}>
                        {yearsData.length}
                    </span> */}
                    {role !== user_role.PRIMARY_CLIENT && <span>{record?.fy_count}</span>}
                    <Button
                        type="primary"
                        // onClick={() => navigate(`/${companyName}/${normalizeEntityName(record?.title)}`)}
                        style={{
                            marginLeft: `${role !== user_role.PRIMARY_CLIENT ? '40px' : '10px'} `,
                            // padding: '5px 10px',
                            // backgroundColor: '#1890ff',
                            // color: 'white',
                            // border: 'none',
                            // borderRadius: '4px',
                            // cursor: 'pointer'
                        }}
                    >
                        Show FY
                    </Button>
                </div>
            ),
            onCell: (record) => ({
                onClick: () => {
                    if (selectedPrimaryClient?._id) {
                        navigate(`/${companyName}/${selectedPrimaryClient?._id}/${normalizePath(record?.title + ':' + record.abn)}`);
                        return
                    }
                    navigate(`/${companyName}/${normalizePath(record?.title + ':' + record.abn)}`)
                },
            }),
        },
        {
            title: `No. of Queries`,
            key: "query_count",
            dataIndex: "query_count",
            width: 200,
            render: (text, record) => (
                <div className="pointer text-center" style={{ maxWidth: '200px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                    <span>{record?.query_count}</span>
                </div>
            ),
            onCell: (record) => ({
                onClick: () => {
                    navigate(`/${companyName}/${normalizePath(record?.title + ':' + record.abn)}`);
                },
            }),
        },
        ...((role === user_role.ADMIN || role === user_role.ACCOUNTANT) && !selectedPrimaryClient?._id
            ? [
                {
                    title: `${role === user_role.PRIMARY_CLIENT ? "Financial Year" : "No. of Financial Years"}`,
                    dataIndex: "migrate_query",
                    key: "migrate_query",
                    render: (text, record) => (
                        <div className="pointer">
                            <Button
                                type='primary'
                                style={{
                                    marginLeft: `${role !== user_role.PRIMARY_CLIENT ? '40px' : '10px'} `,
                                    // padding: '5px 10px',
                                    // backgroundColor: '#1890ff',
                                    // color: 'white',
                                    // border: 'none',
                                    // borderRadius: '4px',
                                    // cursor: 'pointer',
                                }}
                                onClick={() => {
                                    handleMigrateQuery(record)
                                }}
                            >
                                Migrate Entity
                            </Button>
                        </div>
                    ),
                },
            ]
            : []),
        ...(role !== user_role.PRIMARY_CLIENT && !selectedPrimaryClient?._id
            ? [
                {
                    title: `Edit`,
                    key: "edit",
                    render: (text, record) => (
                        <div>
                            {
                                buttonVisible === record?._id ?
                                    <div className='d-flex flex-row align-items-center justify-content-around w-100'>
                                        <Button
                                            onClick={() => {
                                                setEditAbn(false);
                                                setEditTitle(false);
                                                setButtonVisible('');
                                            }}
                                            size='small'
                                            style={{ fontSize: '10px', marginRight: '5px' }}
                                        >
                                            Cancel
                                        </Button>
                                        <Button
                                            type='primary'
                                            onClick={() => {
                                                UpdateClient(record?._id);
                                                setEditTitle(false);
                                                setEditAbn(false);
                                                setButtonVisible('');
                                                dispatch(setReloadClient(true));
                                            }}
                                            size='small'
                                            style={{ fontSize: '10px' }}
                                        >
                                            Update
                                        </Button>
                                    </div>
                                    :
                                    <Button
                                        type='text'
                                        className='my-1'
                                        onClick={
                                            () => {
                                                setButtonVisible(record?._id)
                                                handleEdittitle(record)
                                                handleEditabn(record)
                                                // }
                                            }
                                        }                               >
                                        <EditOutlined size={15} />
                                    </Button>

                            }

                        </div>
                    )
                },
                {
                    title: `+ FY`,
                    key: "fy",
                    render: (record) => (
                        <div style={{ minWidth: "50px" }}>
                            <AddFy client_id={record?._id} years={record.financial_years} />
                        </div>
                    )
                },
            ]
            : []),
    ];

    if (user.role === user_role.ADMIN && !selectedPrimaryClient?._id) {
        columnData.push({

            title: `Trash`,
            key: "trash",
            render: (record) => (
                <div>


                    <Button
                        type='text'
                        className='ms-3'
                        onClick={() => {
                            setPermissionModalOpen(record)
                        }}
                    >
                        <DeleteOutlined size={15} />
                    </Button>


                </div>
            )
        });
    }

    const UpdateClient = async (client_id) => {
        try {
            const payload = {
                "title": title,
                "abn": abn,
                "client_id": client_id
            }
            await updateClient(payload);
            if (isUpdateSuccess) {
                message.success("Client updated successfully");
                setShowData((prevData) =>
                    prevData.map((item) =>
                        item._id === client_id
                            ? { ...item, title: title, abn: abn }
                            : item
                    )
                );
            }

        } catch (e) {
            message.error(e.response.data.response || 'Some error occurred while updating entity')
            console.error(e);
        }
    }

    async function deleteEntity() {

        try {
            const body = {
                client: permissionModalOpen,
                company: company
            }
            let data = await deleteClient(body);
            if (data.status == 200) {
                if (Math.ceil(data?.data?.totalClients / 10) <= pagination?.current && pagination?.current > 1) {
                    setPagination((prev) => {
                        let newdata = {
                            ...prev,
                            total: data?.data?.totalClients,
                            current: Math.ceil(data?.data?.totalClients / 10),
                        }
                        return newdata
                    });
                    message.success('Entity deleted successfully');
                }
                else {
                    setPagination((prev) => {
                        let newdata = {
                            ...prev,
                            total: data?.data?.totalClients,
                        }
                        return newdata
                    });
                    message.success('Entity deleted successfully');
                }
            }
            else {
                message.error('Error while deleting Entity');
            }
        } catch (err) {
            message.error('Some error occurred while deleting entity');
            console.error(err);
        } finally {
            setPermissionModalOpen(null);
        }
    }


    return (
        <>


            <div>
                <Row gutter={[24, 0]}>
                    <Col xs={24} className="mb-<FySidebar 24">
                        <Card
                            className='header-solid h-full'
                            variant="outlined"
                            style={{ body: { paddingTop: 0 } }}
                            title={[
                                <div className='d-flex flex-col'>
                                    <div className="flex-fill search d-flex">
                                        <div className="d-flex flex-fill justify-content-center">
                                            <SearchBox all={showData}
                                                setshow={setShowData}
                                                name={placeholder}
                                                setFilter={setTableFilters}
                                                filterKey={'title'} />
                                        </div>
                                    </div>
                                </div>
                            ]}
                        >
                            <Col>
                                <Table
                                    onRow={(record, rowIndex) => {
                                        return {
                                            onClick: async (event) => {
                                                // await dispatch(changeSelectedClient(record));
                                            },
                                        };
                                    }}
                                    columns={columnData}
                                    dataSource={showData}
                                    pagination={{
                                        current: pagination?.current,
                                        pageSize: pagination?.pageSize,
                                        total: pagination?.total,
                                        showSizeChanger: false,
                                        // onChange: handleTableChange
                                    }}
                                    sortDirections={["descend", "ascend"]}
                                    loading={loading}
                                    onChange={handleTableChange}
                                />
                            </Col>
                        </Card>
                    </Col>
                </Row>
                <PermissionModal
                    visible={permissionModalOpen !== null}
                    setVisible={setPermissionModalOpen}
                    onSuccess={deleteEntity}
                    child={
                        <p>Are you sure you want to delete this <b>Entity</b>? This will delete all the <b>Financial Years</b>, <b>Queries</b>, and <b>Attachments</b> related to this Entity.</p>
                    }
                />
                <RequestFy
                    visible={openFyModal}
                    setVisible={setOpenFyModal}
                />
                <Modal
                    title="Migrate Query"
                    open={isModalVisible}
                    onCancel={() => {
                        setIsModalVisible(false)
                        setTargetCompanyId(null);
                    }}
                    onOk={handleSave}
                    okText="Save"
                >
                    <div style={{ marginBottom: "16px" }}>
                        <label>Entity Name</label>
                        <div style={{ fontWeight: 600 }}>{currentRecord?.title}</div>
                    </div>
                    <div style={{ marginBottom: "16px" }}>
                        <label>Current Company</label>
                        <Select
                            style={{ width: "100%" }}
                            value={company?.name}
                            disabled
                        >
                            <Option value={company?._id}>
                                {company?.name}
                            </Option>
                        </Select>
                    </div>

                    <div>
                        <label>Target Company</label>
                        <Select
                            style={{ width: "100%" }}
                            placeholder="Select target company"
                            onChange={value => setTargetCompanyId(value)}
                            value={targetCompanyId}
                        >
                            {companyList
                                ?.filter(c => c._id !== company?._id)
                                ?.map(com => (
                                    <Option key={com._id} value={com._id}>
                                        {com.name}
                                    </Option>
                                ))}
                        </Select>
                    </div>
                </Modal>
            </div>


        </>

    );

}